import React, { useState } from 'react';
import MessageCard from '../../../../components/card/message-card';
import DateWithTimeCtrl from '../../../../components/UI/Input/date-time/date-with-time-ctrl';
import { RentalExtensionRequest } from '../../../../services/entities/requests/rental-extension-request';
import { RequestHandleType } from '../../../../shared/utility/enum-utility';
import RentalInformation from './rental-information';

function CalculatePriceForm(props) {
    const [returnData, setReturnDate] = useState(null);
    const { getRentalExtensionCharges, extensionResponse, reservationInfo, errorMsg } = props;
    const onDateSelect = (margedDateTime) => {
        setReturnDate(margedDateTime);
    }
    const retrieveRentalExtensionCharges = () => {
        const extensionObj = {
            email: extensionResponse?.rentalExtension?.email,
            firstName: extensionResponse?.rentalExtension?.firstName,
            lastName: extensionResponse?.rentalExtension?.lastName,
            rentalAgreementNum: extensionResponse?.rentalExtension?.rentalAgreementNum,
            returnDate: returnData,
        }
        const chargeReq = new RentalExtensionRequest({ rentalExtension: { ...extensionObj }, charges: true });
        getRentalExtensionCharges(chargeReq, RequestHandleType.RESPONSE_ONLY);
    }
    return (
        <div className='flex-column row-gap-1' style={{ width: "50%" }}>
            <RentalInformation rentalData={extensionResponse?.rentalExtension} reservationInfo={reservationInfo} />
            <div className='flex-column row-gap-1 extend-calculate-form'>
                <h2>New Date & Time</h2>
                {errorMsg ?
                    <MessageCard
                        contClasses="msg-error-block"
                        title={errorMsg?.messageType}
                        message={errorMsg?.displayMessage}
                        iconClass="fas fa-exclamation-triangle error-icon"
                    /> : ""
                }
                <DateWithTimeCtrl
                    key="pick-up-date"
                    placeholder="Pick-up Date"
                    dropUp={true}
                    onChange={onDateSelect}
                    dateVal={returnData}
                    timeVal={returnData}
                    value={returnData}
                    contClass={errorMsg ? "error-container" : ""}
                />
                <div className='btn-container'>
                    <button
                        type="button"
                        className={"btn btn-yellow-default fullwidth-btn"}
                        onClick={() => retrieveRentalExtensionCharges()}
                        disabled={!returnData}
                    >
                        Calculate Price
                    </button>
                </div>
                {props?.children}
            </div>
        </div >
    )
}

export default CalculatePriceForm